<template>
  <div class="hero-wrapper">
    <b-navbar>
      <template slot="brand">
        <b-navbar-item class="logo" tag="router-link" :to="{ path: '/' }">
          <img src="../assets/logo.webp" alt="Kinetica logo" />
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">Acasă</b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/despre-noi' }">Despre noi</b-navbar-item>
        <b-navbar-dropdown boxed label="Servicii">
          <b-navbar-item tag="router-link" :to="{ path: '/servicii/kinetoterapie' }">Kinetoterapie</b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/servicii/fizioterapie' }">Fizioterapie</b-navbar-item>
          <b-navbar-item
            tag="router-link"
            :to="{ path: '/servicii/kinetoterapie-pediatrica' }"
          >Kinetoterapie pediatrică</b-navbar-item>
          <b-navbar-item tag="router-link" :to="{ path: '/servicii/masaj' }">Masaj</b-navbar-item>
          <b-navbar-item
            tag="router-link"
            :to="{ path: '/servicii/recuperare-la-domiciliu' }"
          >Recuperare la domiciliu</b-navbar-item>
        </b-navbar-dropdown>
        <b-navbar-item tag="router-link" :to="{ path: '/galerie' }">Galerie</b-navbar-item>
        <b-navbar-item tag="router-link" :to="{ path: '/contact' }">Contact</b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "TheHeader",
};
</script>

<style>
.navbar-item img {
  max-height: 60px !important;
}
</style>
